import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    duration: { type: Number, default: 5000 }
  }

  connect() {
    // Start invisible and fade in
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-10px)"
    
    requestAnimationFrame(() => {
      this.element.style.transition = "all 0.3s ease-out"
      this.element.style.opacity = "1"
      this.element.style.transform = "translateY(0)"
    })
    
    // Auto-dismiss after duration
    this.timeout = setTimeout(() => this.dismiss(), this.durationValue)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-10px)"
    setTimeout(() => this.element.remove(), 300)
  }
}
